import { AppBody } from 'components/App';
import React from 'react';
import styled from 'styled-components'

export const LiquidityBody = styled(AppBody)`
  padding: 0px;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  border-radius: 18px;
`